import CounselorClient from "@/api/CounselorClient";
import UserClient from "@/api/UserClient"

export default class Documents {

  constructor(){
    this.documents = [];
  }

  async initialize($http, counselorId) {
    this.counselorClient = new CounselorClient($http);
    this.userClient = new UserClient($http);
    this.counselorId = counselorId;

    await this.fetch();
  }

  async approveLicense(licenseId) {
    await this.counselorClient.approveLicense(licenseId)
    await this.fetch();
  }
  async rejectLicense(licenseId) {
    await this.counselorClient.rejectLicense(licenseId)
    await this.fetch();
  }
  async removeLicense(licenseId) {
    await this.counselorClient.removeLicense(licenseId)
    await this.fetch();
  }

  async fetch() {
    this.documents = [];
    const response = await this.counselorClient.getCounselorDocuments(this.counselorId);

    if(!response)
      return;
    
    if(response.governmentId)
      this.documents.push({
        documentType: 'governmentId',
        ...response.governmentId
      })

    if(response.insurance)
      this.documents.push({
        documentType: 'insurance',
        ...response.insurance
      })
    
    if(response.originalLicense)
      this.documents.push({
        documentType: 'originalLicense',
        ...response.originalLicense
      })

    if(response.licenses)
      for(const license of response.licenses)
        this.documents.push({
          documentType: 'license',
          ...license
        })
  }
}